import { InputWithAffixes } from "@/components/ui/InputWithAffixes";
import { Label } from "@/components/ui/label";

const VoidedRemarksForm = ({
  setVoidedRemarks,
}: {
  setVoidedRemarks: (value: string) => void;
}): React.JSX.Element => {
  return (
    <>
      <h2 className='mb-4 text-xl font-normal text-center'>Are you sure ?</h2>
      <Label htmlFor='textarea' className='mb-2'>
        Remarks
      </Label>
      <InputWithAffixes
        inputType='textarea'
        onChange={(e) => {
          setVoidedRemarks(e.target.value);
        }}
        placeholder='Tell us why you want this report to be voided.'
      />
    </>
  );
};

export default VoidedRemarksForm;
